import { useMemo } from "react"

import { IGatsbyImageData } from "gatsby-plugin-image"
import { useI18next } from "gatsby-plugin-react-i18next"

import Carousel from "components/Carousels/Carousel"
import carouselData from "components/Carousels/CarouselData"
import MobileCarousel from "components/MobileCarousel"
import colors from "styles/colors"
import { checkedLocaleLink } from "utils/routes"
import useMedia from "utils/useMedia"

interface Props {
  allCarouselImages: Record<string, IGatsbyImageData | undefined>
}

export default function B2BCarousel({ allCarouselImages }: Props) {
  const { solutions } = carouselData
  const mobile = useMedia(false, false, false, true)
  const { t, language } = useI18next()

  const buttonsArr = [
    { buttonText: t("Deposits") },
    { buttonText: t("Payments & Transfers") },
    { buttonText: t("Credit & Lending") },
  ]
  const DepositsImg = useMedia(
    allCarouselImages.depositsVal,
    allCarouselImages.depositsVal,
    allCarouselImages.depositsVal,
    allCarouselImages.depositsMVal
  )
  const PaymentsImg = useMedia(
    allCarouselImages.readerVal,
    allCarouselImages.readerVal,
    allCarouselImages.readerVal,
    allCarouselImages.readerMVal
  )
  const LimitsImg = useMedia(
    allCarouselImages.loanVal,
    allCarouselImages.loanVal,
    allCarouselImages.loanVal,
    allCarouselImages.loansValM
  )

  const sections = useMemo(
    () => [
      {
        body: t(
          "Improve your customer experience with a myriad of deposit options like direct deposit, early pay, round-up and overdraft capabilities."
        ),
        link: {
          text: t("Explore Deposits"),
          url: checkedLocaleLink("/products/deposits-and-banking", language),
        },
        img: DepositsImg,
      },
      {
        body: t(
          "Seamless and secure transactional experiences are the baseline for payment processing and money transfers today."
        ),
        link: {
          text: t("Payments & Transfers"),
          url: checkedLocaleLink(
            "/products/payment-processing-and-money-transfers",
            language
          ),
        },
        img: PaymentsImg,
      },
      {
        body: t(
          "Whether it’s delivering faster, innovative credit solutions—such as single-use virtual credit cards-or lending services such as personal loans, installment loans, or secured credit, Galileo has you covered."
        ),
        link: {
          text: t("Credit & Lending"),
          url: checkedLocaleLink("/products/credit-and-lending", language),
        },
        img: LimitsImg,
      },
    ],
    [DepositsImg, LimitsImg, PaymentsImg, language, t]
  )

  if (mobile) {
    return (
      <MobileCarousel
        gradient={{
          gradient: `${colors.turqSeaHorz}`,
          fill: `${colors.seaFoam200}`,
        }}
        sections={sections}
        buttonsArr={buttonsArr}
        calloutText={solutions}
      />
    )
  }
  return (
    <Carousel
      gradient={{
        gradient: `${colors.turqSeaHorz}`,
        fill: `${colors.seaFoam200}`,
      }}
      sections={sections}
      buttonsArr={buttonsArr}
      calloutText={solutions}
    />
  )
}
